import { Avatar } from "@mantine/core";
import React from "react";

const MantineIcons = (props: any) => {

    const { iconComponent: IconComponent, onClick, className, variant, size, color, stroke, avtharClassName, avatharColor } = props;

    return (
        <Avatar variant={variant} onClick={onClick} color={avatharColor} className={`${avtharClassName}`}>
            {/* Render the dynamically found icon component */}
            <IconComponent
                size={size}
                color={color}
                stroke={stroke}
                className={`cursor-pointer ${className} `}
            />
        </Avatar>
    );
};
export default MantineIcons